import { ArrowUpward } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FieldArrayRenderProps } from "formik";

export function OrderAdornment(props: {
  index: number;
  arrayHelpers: FieldArrayRenderProps;
}) {
  const { index, arrayHelpers } = props;

  return (
    <IconButton
      onClick={() => arrayHelpers.swap(index, index - 1)}
      sx={{ visibility: index > 0 ? "visible" : "hidden" }}
    >
      <ArrowUpward />
    </IconButton>
  );
}
